import { keyframes, styled } from '@mui/material';
import { Colors } from 'library';
import { Stack } from 'library/ui';

const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const scaleIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

export const FadeSlideIn = styled('div')<{ delay?: number }>(({ delay = 0 }) => ({
    opacity: 0,
    animation: `${fadeSlideUp} 0.4s ease-out ${delay}ms forwards`,
}));

export const AnimatedLogo = styled('img')<{ width?: number }>(({ width = 60 }) => ({
    width,
    marginBottom: 12,
    opacity: 0,
    animation: `${scaleIn} 0.5s ease-out 100ms forwards`,
}));

export const HeaderSection = styled(Stack)({
    background: `linear-gradient(135deg, ${Colors.primaryMuted} 0%, ${Colors.primaryDarkened} 100%)`,
});
